import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';

export const isOpenEventMarket = (market: EventMarketItemType): boolean => {
    return market.active === true && market.display === true;
};

/** Hard filter — no fallback to suspended/hidden markets. */
export const filterOpenEventMarkets = (markets: Array<EventMarketItemType>): Array<EventMarketItemType> => {
    return markets.filter(isOpenEventMarket);
};

/**
 * Prefer open (active + displayed) markets when picking a line for the **unified** event row.
 * Falls back to the full list when every candidate is suspended / hidden.
 * Do not use on classic list pickers.
 */
export const preferOpenEventMarkets = (markets: Array<EventMarketItemType>): Array<EventMarketItemType> => {
    const open = filterOpenEventMarkets(markets);
    return open.length > 0 ? open : markets;
};

export const preferOpenMarketModels = (markets: Array<MarketModel>): Array<MarketModel> => {
    const open = markets.filter((market) => market.activeAndDisplayed);
    return open.length > 0 ? open : markets;
};

/** Same index heuristic as event-row 6-packs, but only among open markets when possible. */
export const pickPreferredLineMarket = (markets: Array<MarketModel>): MarketModel | undefined => {
    const preferred = preferOpenMarketModels(markets);
    if (preferred.length === 0) {
        return undefined;
    }
    return preferred.length === 1 ? preferred[0] : preferred[1] ?? preferred[0];
};
